// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  owner: __t.identity(),
  name: __t.string(),
  public: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
  pendingServed: __t.u32().name("pending_served"),
  pendingTipsCents: __t.i64().name("pending_tips_cents"),
  pendingRatingSumX100: __t.i64().name("pending_rating_sum_x100"),
  pendingRatingCount: __t.u32().name("pending_rating_count"),
  cachedStyleX100: __t.i32().name("cached_style_x100"),
  cachedComfortX100: __t.i32().name("cached_comfort_x100"),
  cachedRatingBonusX100: __t.i32().name("cached_rating_bonus_x100"),
  cachedBathroomQualityX100: __t.i32().name("cached_bathroom_quality_x100"),
  dayElapsedMs: __t.i64().name("day_elapsed_ms"),
  pendingDaysAdvanced: __t.u32().name("pending_days_advanced"),
  cloudMoneyCents: __t.i64().name("cloud_money_cents"),
  pendingRestockCostCents: __t.i64().name("pending_restock_cost_cents"),
  pendingRecipeUpgradesCompletedCsv: __t.option(__t.string()).name("pending_recipe_upgrades_completed_csv"),
  pendingTrainingCompletionsCsv: __t.option(__t.string()).name("pending_training_completions_csv"),
  pendingSalaryCostCents: __t.i64().name("pending_salary_cost_cents"),
  pendingSalaryRemainderX: __t.i64().name("pending_salary_remainder_x"),
  lastSalaryTickMicros: __t.i64().name("last_salary_tick_micros"),
  cloudBasePayrollPerMinCents: __t.i64().name("cloud_base_payroll_per_min_cents"),
  cloudDailyRevenueCents: __t.i64().name("cloud_daily_revenue_cents"),
  cloudDailyExpensesCents: __t.i64().name("cloud_daily_expenses_cents"),
  cloudRatingHistoryCsv: __t.option(__t.string()).name("cloud_rating_history_csv"),
  cloudTransactionLogJson: __t.option(__t.string()).name("cloud_transaction_log_json"),
  cloudDayHistoryJson: __t.option(__t.string()).name("cloud_day_history_json"),
  waiterRestSet: __t.bool().name("waiter_rest_set"),
  waiterRestX: __t.f32().name("waiter_rest_x"),
  waiterRestZ: __t.f32().name("waiter_rest_z"),
  waiterRestFloor: __t.u32().name("waiter_rest_floor"),
  lastGuestSpawnMicros: __t.i64().name("last_guest_spawn_micros"),
  pendingRevenueCents: __t.i64().name("pending_revenue_cents"),
  themeOverridesCsv: __t.option(__t.string()).name("theme_overrides_csv"),
  signFont: __t.option(__t.string()).name("sign_font"),
  signTextColor: __t.option(__t.string()).name("sign_text_color"),
  signPlaqueStyle: __t.option(__t.string()).name("sign_plaque_style"),
  pendingLost: __t.u32().name("pending_lost"),
  cachedAttractionBonusX100: __t.i32().name("cached_attraction_bonus_x100"),
  boostExpiresAtMicros: __t.i64().name("boost_expires_at_micros"),
  cloudDailyServed: __t.u32().name("cloud_daily_served"),
  cloudDailyLost: __t.u32().name("cloud_daily_lost"),
  healthSummaryCsv: __t.option(__t.string()).name("health_summary_csv"),
  cloudDailyTipsCents: __t.i64().name("cloud_daily_tips_cents"),
  lastGrantMicros: __t.i64().name("last_grant_micros"),
  lastLowBalanceGrantMicros: __t.i64().name("last_low_balance_grant_micros"),
  lastRecycleMicros: __t.i64().name("last_recycle_micros"),
  cumulativeAchievementCents: __t.i64().name("cumulative_achievement_cents"),
  homeBuildingId: __t.u64().name("home_building_id"),
  lastTipBonusMicros: __t.i64().name("last_tip_bonus_micros"),
  lastCrateMicros: __t.i64().name("last_crate_micros"),
  lastCrateGift: __t.option(__t.string()).name("last_crate_gift"),
  lastBusSeatMicros: __t.i64().name("last_bus_seat_micros"),
  autoShopEnabled: __t.bool().name("auto_shop_enabled"),
});
